import React, {Fragment} from "react";
import Button from "../Button";
import Modal from "../../layout/Modal";
import Portal from "../../layout/Portal";
import Select from "../Select";
import classNames from "classnames";
import NodeEditor from "./NodeEditor";
import Confirm from "../Confirm";
import Tooltip from "../../../utils/Tooltip";

export default class Module extends React.Component {

    state = {
        collapsed: true
    };

    render() {
        if (this.props.excluded) return <div />;
        return (
            <div className={classNames("module-holder", {disabled: this.props.disabled})}>
                {!this.props.head && this.props.partIndex === 0 && <div className="add-module">
                    <Select
                        label={false}
                        storeType="local"
                        labelKey="name"
                        valueKey="id"
                        placeholder="Új modul beszúrása"
                        disabled={this.props.disabled}
                        objectValue={false}
                        options={this.props.modules || []}
                        saveChanges={(field, moduleId) => {
                            this.props.onPartInsert(-1, moduleId);
                        }}
                    />
                </div>}
                <div className="module">
                    <div className="data">
                        <div className="name" onClick={() => this.setState({collapsed: !this.state.collapsed})}><Tooltip title={this.props.module.name}>{this.props.module.name}</Tooltip></div>
                        <div className="actions">
                            {!this.props.fixed && this.props.drag}
                            {!this.props.disabled && !this.props.head && <Button tooltip="Mutass meg!" icon={{lib: "fas", name: "hand-point-right"}} className="focus-btn" onClick={this.props.onFocusSection}/>}
                            {!this.props.disabled && !this.props.head && <Button tooltip="Másolás" icon={{lib: "fas", name: "paste"}} className="focus-btn" onClick={() => this.props.onPartPaste()} />}
                            {!this.props.fixed && this.props.onPartRemove && <Confirm
                                icon={{lib: "fas", name: "trash"}}
                                className="remove-btn"
                                color="danger"
                                header="Törlés"
                                tooltip="Törlés"
                                acceptButton="Törlés"
                                body="Biztos törlöd?"
                                onAccept={() => this.props.onPartRemove(this.props.partIndex)}
                            />}
                        </div>
                    </div>
                </div>
                <div className={classNames("variables", {collapsed: this.state.collapsed})}>
                    {!!this.props.part && Object.keys(this.props.part.variables).map((variableName) => {
                        const variableData = this.props.part.variables[variableName];
                        return <NodeEditor
                            component={this.props.component}
                            componentId={this.props.componentId}
                            onVariableChanged={this.props.onVariableChanged}
                            type={variableData.type}
                            variableName={variableName}
                            variable={variableData.data}
                        />
                    })}
                </div>
                {!this.props.head && <div className="add-module">
                    <Select
                        label={false}
                        storeType="local"
                        labelKey="name"
                        valueKey="id"
                        placeholder="Új modul beszúrása"
                        disabled={this.props.disabled}
                        objectValue={false}
                        options={this.props.modules || []}
                        saveChanges={(field, moduleId) => {
                            this.props.onPartInsert(1, moduleId);
                        }}
                    />
                </div>}
            </div>
        );
    }
}